import { AgentSearchFilter } from "../user-info";

export const USER_LISTING_RETRIEVE_START = 'USER_LISTING_RETRIEVE_START';
export const USER_LISTING_RETRIEVE_SUCCESS = 'USER_LISTING_RETRIEVE_SUCCESS';
export const USER_LISTING_RETRIEVE_FAILED = 'USER_INFO_RETRIEVE_FAILED';
export const USER_LISTING_SORT = 'USER_LISTING_SORT';
export const USER_LISTING_FILTER = 'USER_LISTING_FILTER';
export const USER_LISTING_NAVPAGE = 'USER_LISTING_NAVPAGE';

export const AGENT_TABLE_LENGTH_PER_PAGE = 10;

export const FIELD_MAPPINGS: Record<string, string> = {
  agentId: 'profileCode',
  role: 'title',
  accessType: 'role'
};

export interface UserListingResponse {
  records: {
    firstName: string;
    lastName: string;
    emailAddress: string;
    role: string;
    agentId: string;
    organizationCode: string;
    status: string;
    sellerCode?: string;
    profileCode?: string;
    profileRef?: string;
    employmentType?: string;
  }[];
}

export interface AgentSlice {
  isAgentFailure: Boolean;
  isAgentLoading: Boolean;
  isAgentSuccess: Boolean;
  searchFilter: Partial<AgentSearchFilter>;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  searchResult: Partial<AgentSearchResult>[];
  searchResultTotalCount: number;
  currentPage: number;
  totalPages: number;
  searchResultRaw: AgentSearchResult[];
  isRolesLoading: Boolean;
  isRolesSuccess: Boolean;
  isRolesFailure: Boolean;
  roles: any;
}

export interface UserListingStore {
  retrieveLoading?: boolean;
  data?: UserListingResponse;
  retrieveError?: unknown;
  sort?: {
    field: string;
    order: string;
  };
  filteredBy?: string;
  currentPageIdx?: number;
}

export interface ProfileResponse {
  id: string;
  agentId?: string;
  organizationCode: string;
  status?: string;
  user?: {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    language: string;
    province: string[];
    userRef: string;
    employmentType: string;
  };
  agencyCode?: string;
  sellerCode?: string;
}

export interface AgentSearchResult {
  firstName: string;
  lastName: string;
  profileRef: string;
  role: string;
  profileCode: string;
  status: string;
  title: string;
}

export interface Agent {
  agentName: string;
  agentId: string;
  profileRef: string;
  role: string;
  status: string;
  accessType: string;
}

export interface AgentSearchResponse {
  total: number;
  agents: AgentSearchResult[];
}

export interface Roles {
  category: string;
  description: string;
  role: string;
}
export interface AgentRoles {
  data: Roles[];
}